module.exports = __webpack_public_path__ + "static/media/icon_10.e114e29f.svg";